'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { gray10 } from '@spotify-internal/encore-foundation';
import { DisabledOverlay } from "../MegaSelector/DisabledOverlay.mjs";
import { LoadingIndicator } from "../../../core/components/LoadingIndicator/index.mjs";
import styled, { css } from "../../../core/styled-components.mjs";
import { cssBorderRadius, cssBorderWidth, cssColorValue, cssSpacing, cursorDisabled, opacityDisabled, semanticColors } from "../../../core/styles/index.mjs";
function getBorderColor(props) {
  if (props.error) return cssColorValue(semanticColors.essentialNegative);
  if (props.warning) return cssColorValue(semanticColors.essentialWarning);
  return cssColorValue(semanticColors.decorativeSubdued);
}
var LoadingWrapper = styled.div.withConfig({
  displayName: "AdsBox__LoadingWrapper",
  componentId: "sc-nkmdwy-0"
})(["position:absolute;inset:0;display:flex;align-items:center;justify-content:center;"]);
var Content = styled.div.withConfig({
  displayName: "AdsBox__Content",
  componentId: "sc-nkmdwy-1"
})(["display:flex;flex-direction:column;"]);
export var StyledAdsBox = styled.div.withConfig({
  displayName: "AdsBox__StyledAdsBox",
  componentId: "sc-nkmdwy-2"
})(["display:flex;position:relative;flex-direction:column;flex:0 0 auto;background-color:", ";border:", " solid ", ";box-shadow:", ";text-align:left;hr{margin-left:0;margin-right:0;}", " ", " &[disabled],&[aria-disabled='true']{cursor:", ";> ", "{pointer-events:none;opacity:", ";}}"], function (props) {
  return props.elevated ? cssColorValue(semanticColors.backgroundElevatedBase) : cssColorValue(semanticColors.backgroundBase);
}, cssBorderWidth('hairline', '1px'), getBorderColor, function (props) {
  return props.elevated ? "0 4px 8px ".concat(gray10, "1A") : 'none';
}, function (_ref) {
  var boxSize = _ref.boxSize;
  return css(["padding:", ";border-radius:", ";"], boxSize === 'sm' ? cssSpacing('base', '16px') : cssSpacing('looser-2', '32px'), boxSize && boxSize === 'sm' ? cssBorderRadius('larger-2', '8px') : cssBorderRadius('larger-3', '16px'));
}, function (_ref2) {
  var loading = _ref2.loading;
  return loading && css(["", "{pointer-events:none;opacity:0.1;}"], Content);
}, cursorDisabled, Content, opacityDisabled);
export var AdsBox = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded);
  // Make use of disabled styles as well if using disabled overlay
  if (props.disabledOverlay) {
    props.disabled = true;
  }
  return /*#__PURE__*/React.createElement(StyledAdsBox, Object.assign({
    ref: ref
  }, props), props.disabledOverlay && /*#__PURE__*/React.createElement(DisabledOverlay, null), props.loading && /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(LoadingIndicator, {
    size: "large",
    "aria-valuetext": "loading"
  })), /*#__PURE__*/React.createElement(Content, null, children));
});